var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAaaCreditCardImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 296,
    height: 88,
    viewBox: "0 0 296 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6C0 2.68629 2.68629 0 6 0H290C293.314 0 296 2.68629 296 6V88H0V6Z",
    fill: "#E9F7DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M171.333 40.8891H124.667V33.1113H171.333V40.8891Z",
    fill: "#3E6B20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M166.148 25.3335C169.008 25.3335 171.333 27.6547 171.333 30.5187V33.1113H124.667V30.5187C124.667 27.6547 126.988 25.3335 129.852 25.3335H166.148ZM171.333 56.4446C171.333 59.3046 169.008 61.6298 166.148 61.6298H129.852C126.988 61.6298 124.667 59.3046 124.667 56.4446V40.8891H171.333V56.4446ZM133.741 51.2594C133.028 51.2594 132.444 51.8428 132.444 52.5557C132.444 53.2687 133.028 53.852 133.741 53.852H138.926C139.639 53.852 140.222 53.2687 140.222 52.5557C140.222 51.8428 139.639 51.2594 138.926 51.2594H133.741ZM144.111 53.852H154.482C155.194 53.852 155.778 53.2687 155.778 52.5557C155.778 51.8428 155.194 51.2594 154.482 51.2594H144.111C143.398 51.2594 142.815 51.8428 142.815 52.5557C142.815 53.2687 143.398 53.852 144.111 53.852Z",
    fill: "#3E6B20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAaaCreditCardImage);
export default __webpack_public_path__ + "static/media/aaa-credit-card-image.515fdb11c9b58f66438ae1ecd4f9aa83.svg";
export { ForwardRef as ReactComponent };